import Store from '../Redux/Store';
import { apiGetAllCategories } from '../Api/Documents/Documents';

const _returnError = (status) => {
  return {
    error: true,
    status
  };
};

const _getAllCategories = async (silently = false, withFilter = false) => {
  const categories = Store.getState().DocumentsReducer.categories;
  if (categories.length > 0) {
    return categories;
  }
  const res = await apiGetAllCategories(silently);
  // const res = []
  if (res.status !== 200) return _returnError(res.status);
  if (withFilter) {
    res.data = res.data.filter((elem) => { return !((elem.name == "Justificatif Enfant") || (elem.name == "Portabilité")) })
  }
  Store.dispatch({
    type: 'SET_ALL_CATEGORIES',
    value: res.data
  });
  return res.data;
};

const getAllCategories = async (contractFamily = []) => {
  return _getAllCategories(false, !contractFamily.includes('SANTE'));
};
const getAllCategoriesSilently = async () => {
  return _getAllCategories(true);
};

const getParentCategoryByName = async (name) => {
  const categories = await getAllCategories();
  return categories.find((item) => item.name === name)
};
const getCategoryByParentName = () => { };

export default {
  getAllCategories,
  getAllCategoriesSilently,
  getParentCategoryByName
};
